import { apiGet } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { IDistrict } from '../../KnmModule/interfaces/IDistrict';

export async function fetchFederalDistricts(): Promise<IDistrict[]> {
  return apiGet<IDistrict[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/rf-districts`);
}
